import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// ── Meta Pixel (runs once, before React, outside any component) ──
const PIXEL_ID = '1927478928649366';
(function () {
  const w = window as any;
  // If fbq already exists, someone else loaded it — skip entirely
  if (w.fbq) return;
  // If fbevents.js script already in DOM, skip
  if (document.querySelector('script[src*="fbevents.js"]')) return;
  const n: any = w.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
  };
  if (!w._fbq) w._fbq = n;
  n.push = n;
  n.loaded = !0;
  n.version = '2.0';
  n.queue = [];
  const t = document.createElement('script');
  t.async = true;
  t.src = 'https://connect.facebook.net/en_US/fbevents.js';
  document.head.appendChild(t);
  w.fbq('set', 'autoConfig', false, PIXEL_ID);
  w.fbq('init', PIXEL_ID);
  w.fbq('trackSingle', PIXEL_ID, 'PageView');
})();
// ── Preconnect hints ──
const head = document.head;
const preconnectCDN = document.createElement('link');
preconnectCDN.rel = 'preconnect';
preconnectCDN.href = 'https://cdn.magicpatterns.com';
head.appendChild(preconnectCDN);
// Preload hero image (LCP element)
const preloadHero = document.createElement('link');
preloadHero.rel = 'preload';
preloadHero.as = 'image';
preloadHero.href = 'https://cdn.magicpatterns.com/uploads/8zRS2mHcecLm1ubrFD3VLb/ChatGPT-Image-27-ene-2026_-02_13_39.webp';
preloadHero.type = 'image/webp';
head.appendChild(preloadHero);
// Remove unused Google Fonts preconnects if present
document.querySelectorAll('link[rel="preconnect"][href*="fonts.googleapis"], link[rel="preconnect"][href*="fonts.gstatic"]').forEach(el => el.remove());
render(<App data-id="element-107" />, document.getElementById('root'));